/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 12c8603ce3c9ac0d6906ec64ed356aa8 */

import { ConcreteRequest } from "relay-runtime";

export type PartnerProgramEnrollmentBillingCycle = "ANNUAL" | "MONTHLY" | "%future added value";
export type PartnerProgramOffering = "AIRCYCLE" | "APP_BRANDING" | "%future added value";
export type PartnerProgramProductSkuType = "DIGITAL" | "PHYSICAL" | "%future added value";
export type ProgramOfferingVariation = "ADVANCED" | "BASIC" | "%future added value";
export type ServicesAndSubscriptionsRoutesQueryVariables = {};
export type ServicesAndSubscriptionsRoutesQueryResponse = {
    readonly partnerProgramProducts: {
        readonly edges: ReadonlyArray<{
            readonly cursor: string;
            readonly node: {
                readonly id?: string | null | undefined;
                readonly name?: string | null | undefined;
                readonly programOffering?: PartnerProgramOffering | null | undefined;
                readonly variation?: ProgramOfferingVariation | null | undefined;
                readonly billingCycle?: PartnerProgramEnrollmentBillingCycle | null | undefined;
                readonly orderPrice?: number | null | undefined;
                readonly recurringPrice?: number | null | undefined;
                readonly recurringPriceDescription?: string | null | undefined;
                readonly sku?: string | null | undefined;
                readonly skuType?: PartnerProgramProductSkuType | null | undefined;
                readonly partnerProgram?: {
                    readonly id: string | null;
                    readonly name: string | null;
                } | null | undefined;
                readonly parentPartnerProgramProduct?: {
                    readonly id: string | null;
                } | null | undefined;
            };
        } | null>;
    } | null;
};
export type ServicesAndSubscriptionsRoutesQuery = {
    readonly response: ServicesAndSubscriptionsRoutesQueryResponse;
    readonly variables: ServicesAndSubscriptionsRoutesQueryVariables;
};



/*
query ServicesAndSubscriptionsRoutesQuery {
  partnerProgramProducts {
    edges {
      cursor
      node {
        __typename
        ... on PartnerProgramProduct {
          id
          name
          programOffering
          variation
          billingCycle
          orderPrice
          recurringPrice
          recurringPriceDescription
          sku
          skuType
          partnerProgram {
            __typename
            id
            name
          }
          parentPartnerProgramProduct {
            __typename
            id
          }
        }
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programOffering",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "variation",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingCycle",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderPrice",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recurringPrice",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recurringPriceDescription",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sku",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ServicesAndSubscriptionsRoutesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CorePartnerProgramProductConnection",
        "kind": "LinkedField",
        "name": "partnerProgramProducts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CorePartnerProgramProductEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "partnerProgram",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "parentPartnerProgramProduct",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PartnerProgramProduct",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ServicesAndSubscriptionsRoutesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CorePartnerProgramProductConnection",
        "kind": "LinkedField",
        "name": "partnerProgramProducts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CorePartnerProgramProductEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "partnerProgram",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v1/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "parentPartnerProgramProduct",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PartnerProgramProduct",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "12c8603ce3c9ac0d6906ec64ed356aa8",
    "metadata": {},
    "name": "ServicesAndSubscriptionsRoutesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = 'b118fa740e801077ec3a8129fba0e0fd';
export default node;
